<div>
    <app-default-shipping-rate *ngIf="!customizationCompanyService.checkCompanies(companies.JETT)"></app-default-shipping-rate>
    <app-jett-shipping-rate *ngIf="customizationCompanyService.checkCompanies(companies.JETT)"></app-jett-shipping-rate>
</div>
